import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  constructor(public router: Router) { }

  ngOnInit() {
    // this.router.navigate(['/dashboard'])
  }


  cadastrar() {
    const email = (<HTMLInputElement>document.getElementById('email')).value;
    const name  = (<HTMLInputElement>document.getElementById('name')).value;
    const zap   = (<HTMLInputElement>document.getElementById('whatsapp')).value;
    let money = false;
    if ((<HTMLInputElement>document.getElementById('m1')).checked) {
      money = true;
    }

    if (!email) {
      alert('Informe um email válido!');
    } else if (!name) {
      alert('Informe um nome válido!');
    } else {
      const url = 'https://us-central1-wiki-photos.cloudfunctions.net/api/beta';

      const postData = {email: email, name: name, money: money, zap: zap};
      // $.ajax({
      //     type: 'POST',
      //     url: url,
      //     data: JSON.stringify(postData) , // or JSON.stringify ({name: 'jonas'}),
      //     success: function(data) { alert('Cadastro efetuado!\nNos vemos em breve =)'); },
      //     error: function(data) { alert('Ocorreu um erro\nTente novamente!'); },
      //     contentType: 'application/json',
      //     dataType: 'json'
      // });
    }
  }

}
